(function () {
  var SELECTOR = '[data-rxb]';
  var instances = [];

  function num(value, fallback) {
    var n = parseFloat(value);
    return isNaN(n) ? fallback : n;
  }

  function Banner(root) {
    this.root = root;
    this.track = root.querySelector('[data-rxb-track]');
    this.stage = root.querySelector('.rxb__stage');
    this.frame = root.querySelector('[data-rxb-frame]');
    this.bottle = root.querySelector('[data-rxb-bottle]');
    if (!this.track || !this.stage || !this.frame || !this.bottle) return;

    this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.raf = null;
    this.last = -1;
    this.overflow = 0;

    this.mq = matchMedia('(min-width: 768px)');
    this.readVars();
    this.measure();
    this.onScroll = this.schedule.bind(this);
    this.onResize = this.resize.bind(this);
    this.onBreakpoint = this.resize.bind(this);

    addEventListener('scroll', this.onScroll, { passive: true });
    addEventListener('resize', this.onResize);
    if (this.mq.addEventListener) this.mq.addEventListener('change', this.onBreakpoint);
    this.watch();

    this.render(this.progress());
    this.ready = true;
  }

  Banner.prototype.watch = function () {
    if (typeof IntersectionObserver !== 'function') {
      this.timer = setInterval(this.onScroll, 250);
      return;
    }
    this.io = new IntersectionObserver(
      function (entries) {
        var visible = entries[entries.length - 1].isIntersecting;
        if (visible && !this.timer) {
          this.timer = setInterval(this.onScroll, 250);
        } else if (!visible && this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }.bind(this),
      { rootMargin: '200px 0px' }
    );
    this.io.observe(this.track);
  };

  Banner.prototype.measure = function () {
    this.measureOffset();
    this.measurePan();
  };

  Banner.prototype.measureOffset = function () {
    var max = 0;
    var stack = [];
    try {
      stack = document.elementsFromPoint(Math.round(innerWidth / 2), 2) || [];
    } catch (e) {
      stack = [];
    }
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (el === this.root || this.root.contains(el)) continue;
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed') continue;
      if (cs.visibility === 'hidden' || cs.display === 'none') continue;
      if (parseFloat(cs.opacity) < 0.05) continue;
      var r = el.getBoundingClientRect();
      if (r.height > innerHeight * 0.5 || r.width < innerWidth * 0.5) continue;
      if (r.bottom > max) max = r.bottom;
    }
    if (!this.maxOffset || max > this.maxOffset) this.maxOffset = max;
    this.root.style.setProperty('--rxb-offset', Math.round(this.maxOffset) + 'px');
  };

  Banner.prototype.measurePan = function () {
    var cs = getComputedStyle(this.stage);
    var avail = this.stage.clientHeight - num(cs.paddingTop, 0) - num(cs.paddingBottom, 0);
    var next = Math.max(0, Math.round(this.frame.offsetHeight - avail));
    if (next !== this.overflow) {
      this.overflow = next;
      this.last = -1;
    }
  };

  Banner.prototype.readVars = function () {
    var raw = this.mq.matches
      ? this.root.getAttribute('data-rxb-desktop')
      : this.root.getAttribute('data-rxb-mobile');
    var v = (raw || '').split(',');
    this.wStart = num(v[0], 10.508);
    this.wEnd = num(v[1], 21.0786);
    this.topStart = num(v[2], 31.3683);
    this.topEnd = num(v[3], 50.5722);
  };

  Banner.prototype.ease = function (t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  };

  Banner.prototype.progress = function () {
    if (this.reduce) return 1;
    var rect = this.track.getBoundingClientRect();
    var span = this.track.offsetHeight - innerHeight;
    if (span <= 0) return 0;
    return Math.min(1, Math.max(0, -rect.top / span));
  };

  Banner.prototype.render = function (p) {
    if (this.reduce) return;
    var e = this.ease(Math.min(1, p / 0.9));
    if (Math.abs(e - this.last) < 0.0005) return;
    this.last = e;

    this.frame.style.transform = 'translate3d(0,' + (-this.overflow * e).toFixed(2) + 'px,0)';

    var w = this.wStart + (this.wEnd - this.wStart) * e;
    var top = this.topStart + (this.topEnd - this.topStart) * e;
    this.bottle.style.width = w.toFixed(4) + '%';
    this.bottle.style.top = top.toFixed(4) + '%';
  };

  Banner.prototype.schedule = function () {
    if (this.raf) return;
    this.raf = requestAnimationFrame(
      function () {
        this.raf = null;
        var now = Date.now();
        if (!this.measuredAt || now - this.measuredAt > 150) {
          this.measuredAt = now;
          this.measure();
        }
        this.render(this.progress());
      }.bind(this)
    );
  };

  Banner.prototype.resize = function () {
    this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.maxOffset = 0;
    this.readVars();
    this.measure();
    this.last = -1;
    this.schedule();
  };

  Banner.prototype.destroy = function () {
    removeEventListener('scroll', this.onScroll);
    removeEventListener('resize', this.onResize);
    if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this.onBreakpoint);
    if (this.io) this.io.disconnect();
    if (this.timer) clearInterval(this.timer);
    if (this.raf) cancelAnimationFrame(this.raf);
  };

  function init(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.dataset.rxbReady) return;
      var b = new Banner(el);
      if (!b.ready) return;
      el.dataset.rxbReady = 'true';
      instances.push(b);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  addEventListener('load', function () {
    init();
    instances.forEach(function (b) {
      b.readVars();
      b.measure();
      b.last = -1;
      b.render(b.progress());
      b.root.classList.add('rxb--ready');
    });
  });

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    instances = instances.filter(function (b) {
      if (!e.target.contains(b.root)) return true;
      b.destroy();
      return false;
    });
  });
})();
